import { render, staticRenderFns } from "./BlockSelectItem.vue?vue&type=template&id=dbe2a914"
import script from "./BlockSelectItem.vue?vue&type=script&lang=js"
export * from "./BlockSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports